import React from "react";

import styles from "./styles.module.scss";

const Error = ({ children }) => {
    return (
        <div className={styles.error}>
            <span className={styles.error__logo} />
            {children}
        </div>
    );
};

export default Error;
